import { Component, OnInit } from '@angular/core';
import { combineLatest, ReplaySubject } from 'rxjs';
import { WindowAccessor } from '../../../core/accessors/window.accessor';
import { BaseComponent } from '../../../core/components/base.component';
import { LanguageModel, LanguageService as ApiLanguageService } from '../../../core/services/api-services';
import { LanguageService } from '../../../core/services/language.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent extends BaseComponent implements OnInit {
  currentLanguage$ = new ReplaySubject<LanguageModel>(1);
  languages$ = new ReplaySubject<LanguageModel[]>(1);

  constructor(private readonly languageService: LanguageService,
    private apiLanguageService: ApiLanguageService,
    private readonly windowAccessor: WindowAccessor) {
    super();
  }

  ngOnInit(): void {
    combineLatest(this.languages$, this.languageService.currentLanguage$)
      .unsubscribeOnDestroy(this)
      .subscribe(([languages, code]) => {
        if (code) {
          const language = languages.find(c => c.code === code);

          this.currentLanguage$.next(language!);
        }
      });

    this.apiLanguageService.get()
      .unsubscribeOnDestroy(this)
      .subscribe(languages => {
        if (languages) {
          this.languages$.next(languages);
        }
      });
  }

  changeLanguage(code: string): void {
    this.languageService.setLanguage(code);
    this.windowAccessor.get()?.location.reload();
  }
}

